import React from "react";
import ReactDOM from "react-dom/client";
import "./services/diagnosticRecorder"; // Install console/network recorder before anything else
import "./index.css";
import "./i18n"; // Initialize i18n
import App from "./App";

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
